module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "manualRefundmodal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Manual Refund"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n        Manual Retour\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "block-content p-0 row"
  }, [_c('label', {
    staticStyle: {
      "margin": "right 50px"
    }
  }, [_vm._v("Voer een order nummer in: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.OrderNumber),
      expression: "OrderNumber"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "list": "orders",
      "placeholder": "Bijvoorbeeld: NL-123456"
    },
    domProps: {
      "value": (_vm.OrderNumber)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.OrderNumber = $event.target.value
      }, _vm.getOrders]
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "orders"
    }
  }, _vm._l((_vm.orders), function(item) {
    return _c('option', {
      key: item.id
    }, [_vm._v(_vm._s(item.number))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.loadOrder
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])])])]), _vm._v(" "), (_vm.order !== null && _vm.refund !== null) ? _c('refund-form', {
    attrs: {
      "order-id": _vm.order.id,
      "refundId": _vm.refund.id,
      "includeRefundShipmentCosts": false
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dbea381","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/refunds/ManualRefundModal.vue
// module id = 715
// module chunks = 1